const transports = new Set(["usb", "wlan", "wireless-retrieval"]);
const actions = new Set(["connect", "export", "manage"]);

function requiredAccountId(value) {
  const accountId = typeof value === "string" ? value.trim() : "";
  if (!accountId || accountId.length > 64 || [...accountId].some(character => character < " "))
    throw new Error("A current Pirdy account is required before opening Local Control.");
  return accountId;
}

export function localControlHandoffCapabilities(navigatorLike = globalThis.navigator) {
  const platform = String(navigatorLike?.userAgentData?.platform ?? navigatorLike?.platform ?? "");
  const userAgent = String(navigatorLike?.userAgent ?? "");
  const windows = /^win/i.test(platform) || /windows/i.test(userAgent);
  return {
    canRequestAppLaunch: windows,
    directBrowserUsb: false,
    transports: { usb: windows, wlan: false, "wireless-retrieval": false },
  };
}

export function buildLocalControlHandoffUri(transport = "usb", action = "manage") {
  if (!transports.has(transport)) throw new Error("The Local Control transport is not supported.");
  if (!actions.has(action)) throw new Error("The Local Control action is not supported.");
  const query = new URLSearchParams({ transport, action });
  return `pirdy://local-control/v1?${query}`;
}

export function requestLocalControlHandoff(request, environment = {}) {
  const accountId = requiredAccountId(request?.accountId);
  const currentAccountId = requiredAccountId(request?.currentAccountId);
  if (accountId !== currentAccountId)
    throw new Error("The signed-in Pirdy account changed before Local Control could open.");

  const navigatorLike = environment.navigator ?? globalThis.navigator;
  const locationLike = environment.location ?? globalThis.location;
  const capability = localControlHandoffCapabilities(navigatorLike);
  const transport = request?.transport ?? "usb";
  const action = request?.action ?? "manage";
  if (!capability.canRequestAppLaunch)
    throw new Error("Open Pirdy Customer App on Windows to use Local Control.");
  if (capability.transports[transport] !== true)
    throw new Error("Wireless Retrieval is not available. Use USB-C in Pirdy Customer App instead.");
  if (typeof locationLike?.assign !== "function")
    throw new Error("This browser cannot request the Pirdy Customer App handoff.");

  const uri = buildLocalControlHandoffUri(transport, action);
  locationLike.assign(uri);
  return Object.freeze({ accountId, transport, action, uri });
}

export const localControlHandoffContract = Object.freeze({
  scheme: "pirdy",
  host: "local-control",
  path: "/v1",
  directBrowserUsb: false,
  wirelessRetrievalAvailable: false,
});
